<template>
  <div class="login">
    <div class="left">
      <img :src="backURL" class="background" alt="background"/>
    </div>
    <div class="right">
      <img
        :src="logoURL"
        alt="DANONE"
        title="DANONE"
        slot="title"
        class="logo"
      />
      <h1>Hello！</h1>
      <p>欢迎登录<span>达能业务管理平台</span></p>
      <div class="formBox">
        <Form
          ref="formInline"
          :model="formInline"
          :rules="ruleInline"
          inline
          label-position="left"
        >
          <FormItem prop="loginId">
            <Input
              type="text"
              v-model="formInline.loginId"
              placeholder="账户"
              size="large"
            >
              <img
                :src="userNameURL"
                class="inputicon"
                alt="loginId"
                slot="prepend"
              />
            </Input>
          </FormItem>
          <FormItem prop="password">
            <Input
              type="password"
              v-model="formInline.password"
              placeholder="密码"
              size="large"
            >
              <img
                :src="passwordURL"
                class="inputicon"
                alt="password"
                slot="prepend"
              />
            </Input>
          </FormItem>
          <FormItem>
            <Button
              type="primary"
              @click="handleSubmit()"
              :loading="loading"
              size="large"
            >登 录
            </Button
            >
          </FormItem>
        </Form>
        <p class="footer">Copyright&copy;2021 danone</p>
      </div>
    </div>
  </div>
</template>
<script>
  import { encryptAES } from '@/utils/encrypt'

export default {
    name: "login",
    data() {
      return {
        logoURL: require("@/assets/DANONE_LOGO.png"),
        backURL: require("@/assets/loginbg.png"),
        userNameURL: require("@/assets/loginuser.svg"),
        passwordURL: require("@/assets/loginpsw.svg"),
        formInline: {
          loginId: "",
          password: "",
          platformCode: "0004",
        },
        ruleInline: {
          loginId: [
            {
              required: true,
              message: "'Please fill in the user loginId",
              trigger: "blur",
            },
          ],
          password: [
            {
              required: true,
              message: "Please fill in the password.",
              trigger: "blur",
            },
            // { type: 'string', min: 6, message: 'The password length cannot be less than 6 bits', trigger: 'blur' }
          ],
        },
        loading: false,
      };
    },
    created() {
      this.formInline.ip = returnCitySN["cip"];
    },
    methods: {
      handleSubmit() {
        this.$refs["formInline"].validate((valid) => {
          if (valid) {
            this.loading = true;
            let loginData = { ...this.formInline };
          loginData.password = encryptAES(loginData.password);
          this.$api["userLogin"](loginData).then((res) => {
              this.loading = false;
              let d = res.data;
              if (res.code === "200") {
                if(d.token){
                  window.sessionStorage.setItem("loginId", d.loginId);
                  window.sessionStorage.setItem("name", d.name);
                  window.sessionStorage.setItem("roleName", d.roleName);
                  window.sessionStorage.setItem("token", d.token);
                  window.sessionStorage.setItem("menus", encodeURIComponent(JSON.stringify(d.menu)));
                  this.$Message.success("登录成功");
                  // 导航至首页
                  this.$router.replace("/");
                }else{
                  this.$Message.success("Network Error");
                }
              }
            });
          }
        });
      },
    },
  };
</script>

<style scoped>
  .login {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(180deg, #fbfeff 0%, #f5fcff 100%);
  }

  .login .left {
    width: 58vw;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .login .left .background {
    width: 58%;
  }

  .login .right {
    height: 100%;
    flex: 1;
    text-align: center;
    background: url("../../assets/loginrbg.png") no-repeat;
    background-size: 100% 100%;
  }

  .login .right .logo {
    margin-top: 90px;
    width: 25%;
    margin-bottom: 60px;
  }

  .login .right h1 {
    color: #2f50ad;
    font-size: 40px;
    line-height: 39px;
    font-weight: normal;
    margin-bottom: 15px;
  }

  .login .right p {
    color: #a7a7a7;
    font-size: 24px;
    line-height: 39px;
    margin-bottom: 50px;
  }

  .login .right p span {
    color: #0d6efd;
  }

  .login .right .formBox .ivu-form-item {
    width: 50%;
    margin: 12px auto;
  }

  .login .right .formBox .ivu-form-item .ivu-input-group-append,
  .ivu-input-group-prepend {
    background: #fff !important;
  }

  .login .right .formBox .ivu-form-item .ivu-btn {
    margin-top: 14px;
    width: 100%;
    height: 42px;
    border-radius: 5px;
    background: linear-gradient(270deg, #b18afc 0%, #6d61fd 49%, #0d6efd 100%);
  }

  .login .right .footer {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
    margin-top: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue